export default __webpack_public_path__ + "static/media/zw.0f24efd0.svg";